import {
  Button,
  Modal,
  Form,
  Input,
  Upload,
  message,
  Avatar,
  Typography,
  Badge,
} from 'antd'
import { PlusOutlined, CloseCircleOutlined } from '@ant-design/icons'
import React, { useState, useEffect } from 'react'
import UploadlistTypePicture from '../../../../../../components/uploadlistTypePicture/uploadlistTypePicture'
import default1 from '../../../../../../assets/defaultAvatar/default1.png'
import default2 from '../../../../../../assets/defaultAvatar/default2.png'
import default3 from '../../../../../../assets/defaultAvatar/default3.png'
import default4 from '../../../../../../assets/defaultAvatar/default4.png'
import default5 from '../../../../../../assets/defaultAvatar/default5.png'
import default6 from '../../../../../../assets/defaultAvatar/default6.png'
import default7 from '../../../../../../assets/defaultAvatar/default7.png'
import default8 from '../../../../../../assets/defaultAvatar/default8.png'

import handleFileInUploading from '../../../../../../utils/cos'

//新建or编辑弹窗
const EditCommentModal = (props) => {
  //新增房源评价（弹窗）
  const { index, editCommentData, handleEdit } = props
  const [avatar, setAvatar] = useState(editCommentData.avatar)
  const [form] = Form.useForm()
  const [open, setOpen] = useState(false)

  //表单设置
  const { TextArea } = Input
  const [componentDisabled, setComponentDisabled] = useState(false)
  const onFormLayoutChange = ({ disabled }) => {
    setComponentDisabled(disabled)
  }
  const [total, setTotal] = useState(props.total)

  const [confirmLoading, setConfirmLoading] = useState(false)

  const setIsfresh = props.setIsFresh //刷新组件

  const showModal = () => {
    setOpen(true)
  }

  const handleEditComment = () => {
    showModal()
  }
  const handleOk = (e) => {
    const formData = form.getFieldsValue()
    formData.avatar = avatar
    // setNewCommentData(formData)
    handleEdit(formData, index)
    deleteAvatar()
    setOpen(false)
  }

  const handleCancel = () => {
    console.log('Clicked cancel button')
    deleteAvatar()
    setOpen(false)
  }

  //修改头像
  const changeAvatar = () => {}

  //删除头像
  const deleteAvatar = () => {
    setAvatar('')
  }

  //将图片路径转化成文件形式
  const [imageFile, setImageFile] = useState(null)
  const handleFileChange = (imageUrl, name) => {
    const img = new Image()
    img.src = imageUrl
    img.onload = () => {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      canvas.width = img.width
      canvas.height = img.height
      ctx.drawImage(img, 0, 0)
      canvas.toBlob((blob) => {
        const fileFromCanvas = new File([blob], name, {
          type: 'image/png',
        })
        setImageFile(fileFromCanvas)
      }, 'image/png')
    }
  }

  //默认头像选择
  const handleDefaultAvatar = (imageUrl, name) => {
    handleFileChange(imageUrl, name)
  }

  //当handleDefaultAvatar触发后，imagefile改变时，调用上传函数
  //理论上应该最后再最后确认的时候再上传图片，但是应该上传量不大，先上传也无所谓，:)(要是有问题再改吧)
  useEffect(() => {
    const afterUpload = (url) => {
      //  setIsRemove(false)
      const image =
        'https://' + url.replace('cos.accelerate', 'cos-website.ap-shanghai')
      setAvatar(image)
      console.log(image)
      setFresh((pre) => !pre)
      if ((url ?? false) && url !== '') {
        message.success('图片上传成功！')
      }
    }
    handleFileInUploading(imageFile, afterUpload)
  }, [imageFile])

  const [fresh, setFresh] = useState(false)

  useEffect(() => {
    console.log('newAvatar', avatar)
  }, [avatar])

  return (
    <>
      {' '}
      <Typography.Link onClick={handleEditComment}>编辑</Typography.Link>
      <Modal
        title="新增/编辑评价"
        okText="确定"
        cancelText="取消"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        destroyOnClose
      >
        <Form
          // validateMessages={MyValidateMessages}
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          layout="horizontal"
          onValuesChange={onFormLayoutChange}
          disabled={componentDisabled}
          form={form}
          preserve={false}
          initialValues={editCommentData ? editCommentData : null}
        >
          <Form.Item
            label="用户名"
            name="name"
            rules={[
              {
                required: true,
                max: 10,
              },
            ]}
          >
            <Input placeholder="上限10字" />
          </Form.Item>

          <Form.Item
            label="用户头像"
            valuePropName="avatar"
            name="avatar"
            rules={[
              {
                required: true,
              },
            ]}
          >
            {avatar ? (
              <Badge
                count={<CloseCircleOutlined style={{ color: '#f5222d' }} />}
                onClick={deleteAvatar}
              >
                <Avatar src={avatar} />
              </Badge>
            ) : (
              <UploadlistTypePicture
                deliverUrl={setAvatar}
                image={null ?? ''}
              />
            )}
          </Form.Item>

          <Form.Item label="默认头像">
            <Avatar
              style={{ margin: 5 }}
              src={default1}
              onClick={() => handleDefaultAvatar(default1, 'default1')}
            />
            <Avatar
              style={{ margin: 5 }}
              src={default2}
              onClick={() => handleDefaultAvatar(default2, 'default2')}
            />
            <Avatar
              style={{ margin: 5 }}
              src={default3}
              onClick={() => handleDefaultAvatar(default3, 'default3')}
            />
            <Avatar
              style={{ margin: 5 }}
              src={default4}
              onClick={() => handleDefaultAvatar(default4, 'default4')}
            />
            <Avatar
              style={{ margin: 5 }}
              src={default5}
              onClick={() => handleDefaultAvatar(default5, 'default5')}
            />
            <Avatar
              style={{ margin: 5 }}
              src={default6}
              onClick={() => handleDefaultAvatar(default6, 'default6')}
            />
            <Avatar
              style={{ margin: 5 }}
              src={default7}
              onClick={() => handleDefaultAvatar(default7, 'default7')}
            />
            <Avatar
              style={{ margin: 5 }}
              src={default8}
              onClick={() => handleDefaultAvatar(default8, 'default8')}
            />
          </Form.Item>

          <Form.Item
            rules={[
              {
                required: true,
              },
            ]}
            label="评价内容"
            name="content"
          >
            <TextArea rows={4} maxLength={30} placeholder="上限30字" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}

export default EditCommentModal
